module.exports = __webpack_public_path__ + "media/images/c03-289de7409e072051cc459cfe58eb0aea.svg";